import {log} from '../../api/logger';

let registeredActions = new Map();

const registerAction = (action) => {
    const {
        type,
        meta: {limit}
    } = action;
    registeredActions.set(type, {lastApplied: Date.now(), limiterTimeout: limit});
};

const updateAction = registerAction;

const clearRegisteredActions = () => {
    registeredActions.clear();
};

/**
 * Limits the # of times an action can be fired within a specified duration.
 * This middleware targets actions with a `meta.limit` attribute. Affected
 * routes are registered and let through the first time around. The timeout
 * value is checked against on subsequent triggers.
 */
/* eslint-disable no-unused-vars,consistent-return */
const limiter = (store) => (next) => (action) => {
    const {meta} = action;

    // Skip if action is not decorated as expected
    if (!(meta && meta.limit)) {
        return next(action);
    }

    const limitedAction = registeredActions.get(action.type);

    if (!limitedAction) {
        // Register the action and let it fire the first time.
        registerAction(action);
        return next(action);
    }

    const {lastApplied, limiterTimeout} = limitedAction;
    const diff = Date.now() - lastApplied;

    // Let the action go through only when the span of time that's
    // transpired from when it was last triggered is greater than
    // the limiter timeout value.
    if (diff > limiterTimeout) {
        updateAction(action);
        return next(action);
    }

    // Log the action when it doesn't go through
    log({throttledEvent: action.type, timeDiff: diff});
};

export default limiter;
export {limiter, clearRegisteredActions};
